import { PageIntro } from "../components/portfolio/PageIntro";
import { Seo } from "../components/portfolio/Seo";
import { WebDesign } from "../components/portfolio/WebDesign";
import { GraphicDesign } from "../components/portfolio/GraphicDesign";
import { MiniFooter } from "../components/portfolio/MiniFooter";

export default function WebGraphicPage() {
  return (
    <div className="pt-20">
      <Seo
        title="Web & Graphic Design"
        description="Hand-built websites and twenty years of graphic design work for brands, artists, and events."
      />
      <PageIntro kicker="Web & Graphic Design">
        Hand-built websites and twenty years of design work for brands, artists, and events.
      </PageIntro>
      <WebDesign />
      <GraphicDesign />
      <MiniFooter />
    </div>
  );
}
